import React, { useEffect } from 'react';
import { OfferMappingManager } from './OfferMappingManager';
import { useData } from '../../../data-layer';

export function OfferMappings(): React.ReactElement {
  const { offerMappings, coupons } = useData();

  // Coupons back the grid's coupon column and the coupon picker on each
  // SubscriptionManagerCouponMappingItem inside OfferMappingForm.
  useEffect(() => {
    offerMappings.hook.getAll();
    coupons.hook.getAll();
  }, []);

  return <OfferMappingManager />;
}
